import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchGamesList(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/game', {params: queryParams})
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchGame(ctx, {id}) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/game/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addGame(ctx, {game}) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/game/create', game)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        saveGame(ctx, {id, game}) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game/${id}`, game)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteGame(ctx, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/game/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        topicslist(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`autotopic/list`, {params: queryParams})
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchGameWeeks(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/game-week')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        submitSchedule(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/game-schedule/import', payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createWeekPosts(ctx, { week_id, days, create_full }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-week/${week_id}/create-posts`, { days, create_full })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchWeekGames(ctx, { week_id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/game-week/${week_id}/games`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchWeekSummary(ctx, { week_id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/game-week/${week_id}/summary`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        publishWeekSummary(ctx, { week_id, text }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-week/${week_id}/summary/publish`, { text })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchGameReminders(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/game-reminders')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        reviveReminder(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-reminders/${id}/revive`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        publishRating(ctx, { text, musicBlob = null, moviesBlob = null }) {
            const formData = new FormData()
            formData.append('text', text)
            if (musicBlob) formData.append('music_image', musicBlob, 'rating-music.png')
            if (moviesBlob) formData.append('movies_image', moviesBlob, 'rating-movies.png')

            return new Promise((resolve, reject) => {
                axios
                    .post('/game-week/rating/publish', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchPackPostsPreview(ctx, { week_id }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-week/${week_id}/pack-posts/preview`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        generatePackCover(ctx, { week_id, pack_key }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-week/${week_id}/pack-posts/cover`, { pack_key })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        uploadPackVideo(ctx, { week_id, pack_key, file }) {
            const formData = new FormData()
            formData.append('pack_key', pack_key)
            formData.append('video', file)

            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-week/${week_id}/pack-posts/upload-video`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        publishPackStory(ctx, {
            week_id, pack_key, video_path, text,
        }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-week/${week_id}/pack-posts/publish-story`, { pack_key, video_path, text })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        publishPackPosts(ctx, { week_id, posts }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/game-week/${week_id}/pack-posts/publish`, { posts })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateTelegramPosts(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/sync')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        syncReminders(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/sync/reminders', { force: 1 })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        resetRemindersCache(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/sync/reset')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchWeekPlanFact(ctx, { week_id }) {
            return axios.get(`/game-week/${week_id}/plan-fact`)
        },
        fetchPlanfixGames(ctx, params) {
            return axios.get('/planfix-games', { params })
        },
        fetchPlanfixGameHosts() {
            return axios.get('/planfix-games/hosts')
        },
        sendFeedbackRequests(ctx, { task_id }) {
            return axios.post(`/planfix-games/${task_id}/feedback-requests`)
        },
        fetchPlanfixSyncStatus() {
            return axios.get('/planfix-games/sync-status')
        },
        requestPlanfixSync() {
            return axios.post('/planfix-games/sync')
        },
    },
}
